/**
 * Confirmation dialog messages for destructive or important actions.
 */
export const confirmations = {
  assignments: {
    delete: (title: string) => `Are you sure you want to permanently delete the assignment "${title}"? This action cannot be undone.`,
    deleteGeneric: "Are you sure you want to delete this assignment?",
    archive: (title: string) => `Archive the assignment "${title}"?`,
    unarchive: (title: string) => `Restore the assignment "${title}"?`,
  },

  classes: {
    delete: (name: string) => `Are you sure you want to permanently delete the class "${name}"? All students and assignments will be deleted.`,
    deleteGeneric: "Are you sure you want to delete this class?",
    archive: (name: string) => `Archive the class "${name}"?`,
    unarchive: (name: string) => `Restore the class "${name}"?`,
  },

  students: {
    delete: (name: string) => `Are you sure you want to permanently delete the student "${name}"?`,
    deleteGeneric: "Are you sure you want to delete this student?",
    archive: (name: string) => `Archive the student "${name}"?`,
    unarchive: (name: string) => `Restore the student "${name}"?`,
  },

  documents: {
    delete: "Are you sure you want to delete this paper? This action cannot be undone.",
  },

  highlights: {
    delete: "Remove this highlight? This cannot be undone.",
    deleteComment: "Delete this teacher comment? This cannot be undone.",
  },

  criteria: {
    delete: "Are you sure you want to delete this focus area?",
    reset: "Are you sure you want to reset the criteria to defaults? This will replace all current focus areas.",
  },

  criteriaTemplates: {
    delete: (name: string) => `Delete "${name}"? This cannot be undone.`,
    deleteGeneric: "Are you sure you want to delete these criteria?",
  },

  share: {
    revoke: "Are you sure you want to revoke this share link? The link will no longer work.",
  },

  summary: {
    reset: "Are you sure you want to reset the summary to the Markeroo-generated version? Your manual edits will be lost.",
  },

  feedback: {
    deleteGeneric: "Delete this feedback? It will be hidden from the list.",
  },

  generic: {
    archive: (type: string, name: string) => `Archive the ${type} "${name}"?`,
    unarchive: (type: string, name: string) => `Restore the ${type} "${name}"?`,
  },
} as const;

export type ConfirmationString = typeof confirmations;
